import Button from './Button';
import Ripple from './Ripple';
import ConfirmButton from './confirm-button';

Button.ConfirmButton=ConfirmButton;
Button.Ripple = Ripple;
export default Button;